<template>
  <ZigzagServiceLayout
    mainTitle="Serviços de Atenção Primária Geral"
    mainDescription="De crianças a adultos, nossa equipe bilíngue está aqui para fornecer atendimento acessível e personalizado para cada fase da vida."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'PrimaryContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ATENÇÃO PRIMÁRIA',
          title: 'Prevenção e Bem-estar',
          subtitle: 'Visitas regulares para ajudar a monitorar e cuidar da sua saúde.',
          paragraphs: [
            "Check-ups de rotina e cuidados preventivos são essenciais para manter uma saúde ideal.",
            "Oferecemos avaliações completas, vacinações para proteger crianças e adultos, e exames escolares."
          ],
          list: [
            "Exames físicos anuais",
            "Consultas de bem-estar com planos personalizados",
            "Vacinas e imunizações",
            "Exames físicos escolares"
          ],
          image: '/images/services/primary-prevention.png'
        },
        {
          label: 'CUIDADO CRÔNICO',
          title: 'Gerenciamento de Condições',
          subtitle: 'Suporte de longo prazo para suas condições.',
          paragraphs: [
            "Fornecemos monitoramento contínuo para controlar problemas crônicos como diabetes e hipertensão.",
            "Nossos planos de cuidados visam reduzir o risco cardiovascular e auxiliar no controle de peso supervisionado."
          ],
          list: [
            "Gerenciamento de diabetes",
            "Controle de hipertensão e colesterol alto",
            "Distúrbios da tireoide",
            "Obesidade e controle de peso"
          ],
          image: '/images/services/primary-chronic.png'
        },
        {
          label: 'ATENÇÃO ESPECIALIZADA',
          title: 'Exames de Saúde e Agudos',
          subtitle: 'Detecção precoce e alívio rápido.',
          paragraphs: [
            "A detecção precoce salva vidas; oferecemos exames de saúde abrangentes.",
            "Além disso, fornecemos alívio rápido para resfriados e pequenas lesões, além de tratamentos para alergias."
          ],
          list: [
            "Exames de saúde para detecção precoce",
            "Cuidados agudos e consultas de doença",
            "Pequenos ferimentos e cuidados com feridas",
            "Tratamento para dores de cabeça e alergias"
          ],
          image: '/images/services/primary-specialized.png'
        },
        {
          label: 'CUIDADO HOLÍSTICO',
          title: "Saúde Mental, Feminina e Masculina",
          subtitle: 'Suporte abrangente sob medida para você.',
          paragraphs: [
            "Fornecemos cuidados rotineiros para todas as fases da vida, desde aconselhamento anticoncepcional até TRT.",
            "Além disso, oferecemos terapia holística para ansiedade, depressão e TDAH."
          ],
          list: [
            "Exames femininos, SOP e menopausa",
            "Avaliação masculina, DE e TRT",
            "Saúde mental e ansiedade",
            "Pequenos procedimentos: remoção de cistos"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        }
      ]
    };
  }
};
</script>
